import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { quickDepositClickBtnEvent } from '@components-member/psp/deposit/analyticsEvents/depositAnalyticsEvents';
import { getQuickDepositClickBtnEventData } from '@components-member/psp/deposit/analyticsEvents/depositAnalyticsEventsData';
import { EnumUserRoute } from '@components-member/userRoutes/enums';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import styles from './headerQuickDeposit.styles.module.scss';

export const HeaderQuickDeposit = observer(() => {
  const { i18n } = useTranslation();

  const { userProfile, userInfo } = useMobxStore().accountStore;

  const addQuickDepositClickBtnEvent = () => {
    quickDepositClickBtnEvent(getQuickDepositClickBtnEventData(userInfo, userProfile.parentIbUserIdHash));
  };

  return (
    <Link
      id="quickDeposit"
      to={EnumUserRoute.pspDeposit}
      className={cn(styles.headerQuickDepositButton, 'custom-web__quickDeposit')}
      onClick={addQuickDepositClickBtnEvent}>
      {i18n.t(keyMap.accountQuickDeposit)}
    </Link>
  );
});
